module.exports = __webpack_public_path__ + "static/media/hacker-tracker.73607ab5.png";